// extracted by mini-css-extract-plugin
export var accent = "_7z-4";
export var add = "_7z-j";
export var addIcon = "_7z-k";
export var deleteIcon = "_7z-i";
export var disabled = "_7z-9";
export var ellipsis = "_7z-f";
export var error = "_7z-3";
export var form = "_7z-5";
export var hideFocus = "_7z-2";
export var icon = "_7z-7";
export var input = "_7z-e";
export var listItem = "_7z-h";
export var mediumHeight = "_7z-b";
export var noBorder = "_7z-8";
export var noRadius = "_7z-1";
export var shortHeight = "_7z-a";
export var tallHeight = "_7z-c";
export var textInput = "_7z-0";
export var vertical = "_7z-g";
export var veryTallHeight = "_7z-d";
export var widget = "_7z-6";